import React from "react";
import NumberFormat from "react-number-format";
import PhoneInput from "react-phone-number-input";
import nb from "react-phone-number-input/locale/nb.json";
import "react-phone-number-input/style.css";
import "./style.scss";

export const Input = ({
  format = "none",
  type = "text",
  placeholder,
  ...props
}) => {
  if (format === "postal") {
    return (
      <NumberFormat
        format="####"
        className="ldsrf-input"
        placeholder={placeholder ? placeholder : ""}
        type={type}
        {...props}
      />
    );
  }
  if (format === "pin") {
    return (
      <NumberFormat
        maxLength={4}
        className="ldsrf-input"
        placeholder={placeholder ? placeholder : ""}
        type={type}
        {...props}
      />
    );
  }
  if (format === "phone") {
    return (
      <PhoneInput
        className="ldsrf-input"
        labels={nb}
        defaultCountry="NO"
        {...props}
      />
    );
  }
  if (format === "organizationNumber") {
    return (
      <NumberFormat
        format="### ### ###"
        className="ldsrf-input"
        placeholder={placeholder ? placeholder : ""}
        type={type}
        {...props}
      />
    );
  }
  if (format === "amount") {
    return (
      <NumberFormat
        thousandSeparator={" "}
        className="ldsrf-input"
        placeholder={placeholder ? placeholder : ""}
        type={type}
        {...props}
      />
    );
  }
  if (format === "expiration") {
    return (
      <NumberFormat
        format="##/####"
        mask={["M", "M", "Y", "Y", "Y", "Y"]}
        className="ldsrf-input"
        placeholder={placeholder ? placeholder : ""}
        type={type}
        {...props}
      />
    );
  }
  if (format === "cardnumber") {
    return (
      <NumberFormat
        format="#### #### #### ####"
        className="ldsrf-input"
        placeholder={placeholder ? placeholder : ""}
        type={type}
        {...props}
      />
    );
  }
  return (
    <input
      className="ldsrf-input"
      placeholder={placeholder ? placeholder : ""}
      type={type}
      {...props}
    />
  );
};
